import { render, staticRenderFns } from "./YinHuaShuiList.vue?vue&type=template&id=cfdf462e&scoped=true&"
import script from "./YinHuaShuiList.vue?vue&type=script&lang=js&"
export * from "./YinHuaShuiList.vue?vue&type=script&lang=js&"
import style0 from "./YinHuaShuiList.vue?vue&type=style&index=0&id=cfdf462e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfdf462e",
  null
  
)

export default component.exports